export const BACKGROUND = 'background';